require([
],
    function () {
        // Markup, css, and code for the floating-label functionality is taken
        // from https://itnext.io/how-to-build-a-floating-label-input-field-f9b21669fe2f

        // The code is adjusted to the needs of this project.


        // add active class and placeholder 
        const handleFocus = function(e) {
            const target = e.target;
            target.parentNode.classList.add('active');
            const placeholderText = target.getAttribute('data-placeholder');
            if (placeholderText) {
                target.setAttribute('placeholder', target.getAttribute('data-placeholder'));
            }
        };

        // remove active class and placeholder
        const handleBlur = function(e) {
            const target = e.target;
            if (!target.value) {
                target.parentNode.classList.remove('active');
            }
            target.removeAttribute('placeholder');
        };

        // register events
        const bindEvents = function (element) {
            var floatField = element.querySelector('input');
            if (!floatField) floatField = element.querySelector('textarea');
            if (!floatField) floatField = element.querySelector('select');
            if (floatField) {
                // changed this to jQuery events, so they are cloned when jQuery clone is used on the elements
                //floatField.addEventListener('focus', handleFocus);
                //floatField.addEventListener('blur', handleBlur);
                $(floatField).on('focus', handleFocus);
                $(floatField).on('blur', handleBlur);
            }
        };

        // init all floating labels
        const init = function() {
            const floatContainers = document.querySelectorAll('.floating-label-container');

            for (var i = 0; i < floatContainers.length; i++) {
                var element = floatContainers[i];

                var inputElement = element.querySelector('input');
                if (!inputElement) inputElement = element.querySelector('textarea');
                if (!inputElement) inputElement = element.querySelector('select');
                if (inputElement && inputElement.value) {
                    element.classList.add('active');
                }

                bindEvents(element);
            };
        };

        init();
    }
);

define("FloatingLabels/main", function(){});

